/**
 * LayerTypePicker — Grid of available layer types to add to the custom visualization.
 */

import {
  Square, Palette, BarChart3, Activity, Sparkles, Star, Sun, Target, Aperture, Circle,
  AlignVerticalSpaceAround, X,
} from 'lucide-react';
import { LAYER_SCHEMAS } from '../layerSchemas';
import { LayerType } from '../types';

const ICON_MAP: Record<string, React.FC<{ className?: string }>> = {
  Square, Palette, BarChart3, Activity, Sparkles, Star, Sun, Target, Aperture, Circle,
  AlignVerticalSpaceAround,
};

interface LayerTypePickerProps {
  onSelect: (type: LayerType) => void;
  onClose: () => void;
}

export default function LayerTypePicker({ onSelect, onClose }: LayerTypePickerProps) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60]" onClick={onClose}>
      <div className="bg-gray-900 rounded-xl p-4 w-full max-w-md border border-gray-700" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-white">Add Layer</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={16} />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-2">
          {LAYER_SCHEMAS.map(schema => {
            const Icon = ICON_MAP[schema.icon] || Square;
            return (
              <button
                key={schema.type}
                onClick={() => { onSelect(schema.type); onClose(); }}
                className="flex items-start gap-2.5 p-2.5 rounded-lg bg-gray-800/60 hover:bg-gray-700 text-left transition-colors"
              >
                <span className="text-purple-400 mt-0.5">
                  <Icon className="w-4 h-4" />
                </span>
                <div className="min-w-0">
                  <div className="text-xs font-medium text-white truncate">{schema.label}</div>
                  <div className="text-[10px] text-gray-400 leading-tight mt-0.5">{schema.description}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
